import { render, staticRenderFns } from "./TuneDetail.vue?vue&type=template&id=40a24a86&scoped=true"
import script from "./TuneDetail.vue?vue&type=script&lang=js"
export * from "./TuneDetail.vue?vue&type=script&lang=js"
import style0 from "./TuneDetail.vue?vue&type=style&index=0&id=40a24a86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a24a86",
  null
  
)

export default component.exports